import request from '@/utils/request'

// 轮播图
export function bannerList(data) {
  return request({
    url: '/banner/list',
    method: 'get',
    params: data
  })
}
// 热门高手技能列表
export function hotSkillList(data) {
  return request({
    url: '/game/gameSkill/hotSkillList',
    method: 'get',
    params: data
  })
}
// 根据用户ID查询游戏列表
export function gameListByUserId(data) {
  return request({
    url: '/game/game/gameListByUserId',
    method: 'get',
    params: data
  })
}
// 搜索高手技能列表
export function searchSkillList(data) {
  return request({
    url: '/game/gameSkill/searchSkillList',
    method: 'get',
    params: data
  })
}
// 查询用户中心
export function selUserCenter(data) {
  return request({
    url: '/user/userExtend/selUserCenter',
    method: 'get',
    params: data
  })
}
// 魅力排行榜
export function charmRankList(data) {
  return request({
    url: '/rank/rankCharm/charmRankList',
    method: 'post',
    data: data
  })
}
// 礼物排行榜
export function giftRankList(data) {
  return request({
    url: '/rank/rankCharm/giftRankList',
    method: 'post',
    data: data
  })
}
// 财富排行榜
export function wealthRankList(data) {
  return request({
    url: '/rank/rankCharm/wealthRankList',
    method: 'post',
    data: data
  })
}

// 各种协议
export function queryConfig(data) {
  return request({
    url: '/config/queryConfig',
    method: 'get',
    params: data
  })
}

// 签到
export function signIn(data) {
  return request({
    url: '/sign/signUser/signIn',
    method: 'post',
    data: data
  })
}
// 签到详情
export function signDetail(data) {
  return request({
    url: '/sign/signUser/signDetail',
    method: 'get',
    params: data
  })
}
// 是否签到
export function isSign(data) {
  return request({
    url: '/sign/signUser/isSign',
    method: 'post',
    data: data
  })
}